import {
  AlignItemsType,
  BgColorType,
  BorderRadiusType,
  FlexDirectionType,
  FlexWrapType,
  SpacingType,
} from "@/lib/main";
import { CSSProperties, HTMLAttributes, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  bgColor?: BgColorType;
  borderRadius?: BorderRadiusType;

  className?: HTMLAttributes<HTMLDivElement>["className"];
  id?: HTMLAttributes<HTMLDivElement>["id"];

  direction?: FlexDirectionType;
  align?: AlignItemsType;
  justify?: CSSProperties["justifyContent"];
  gap?: SpacingType;
  wrap?: FlexWrapType;

  padding?: SpacingType;
  hPadding?: SpacingType;
  vPadding?: SpacingType;
  fullWidth?: boolean;
  maxWidth?: CSSProperties["maxWidth"];

  style?: CSSProperties;

  onClick?: HTMLAttributes<HTMLDivElement>["onClick"];
}>;

export default function FlexContainer({
  bgColor,
  borderRadius,

  children,
  className,
  id,

  direction,
  align,
  justify,
  gap,
  wrap,

  padding,
  hPadding,
  vPadding,
  fullWidth,
  maxWidth,

  style,

  onClick,
}: Props) {
  const styles: CSSProperties = {
    backgroundColor: bgColor
      ? `var(--color-background-${bgColor})`
      : "transparent",

    borderRadius: borderRadius
      ? `var(--border-radius-${borderRadius})`
      : undefined,

    position: "relative",
    display: "flex",
    flexDirection: direction || "row",
    flexWrap: wrap || "nowrap",
    justifyContent: justify || "center",
    alignItems: align || "center",

    gap: gap ? `var(--spacing-${gap})` : undefined,

    ...(padding && { padding: `var(--spacing-${padding})` }),
    ...(hPadding && { paddingInline: `var(--spacing-${hPadding})` }),
    ...(vPadding && { paddingBlock: `var(--spacing-${vPadding})` }),

    width: fullWidth ? "100%" : "auto",
    maxWidth: maxWidth || undefined,
    ...style,
  };

  return (
    <div className={className} id={id} style={styles} onClick={onClick}>
      {children}
    </div>
  );
}
